import { Injectable } from "../../../../node_modules/@angular/core";
import { ApiService } from "@app/core/services/api.service";
import { Observable } from "../../../../node_modules/rxjs";
import { map } from "../../../../node_modules/rxjs/operators";


@Injectable()
export class ReportService {
  constructor(
    private apiService: ApiService
  ) { }

  getVisitorSummaryData(filter:string): Observable<any> {
    return this.apiService.get('/reports/visitor/summary/'+filter)
    .pipe(
      map(
        res  =>  {
          console.log("response" +  res);
          return res
        },
        err => {
          console.log("error response" + err);
        }
      )
    );
  }

  getVisitorAnalyticsData(filter:string): Observable<any> {
    return this.apiService.get('/reports/visitor/analytics/'+filter)
    .pipe(
      map(
        res  =>  {
          console.log("response" +  res);
          return res
        },
        err => {
          console.log("error response" + err);
        }
      )
    );
  }
  getVisitorAnalyticsPieChartData(filter:string): Observable<any> {
    return this.apiService.get('/reports/visitor/analytics/piechart/'+filter)
    .pipe(
      map(
        res  =>  {
          console.log("response" +  res);
          return res
        },
        err => {
          console.log("error response" + err);
        }
      )
    );
  }

  getRegisteredVSBlockedAnalyticsData(filter:string): Observable<any> {
    return this.apiService.get('/reports/registeredvsblocked/analytics/'+filter)
    .pipe(
      map(
        res  =>  {
          console.log("response" +  res);
          return res
        },
        err => {
          console.log("error response" + err);
        }
      )
    );
  }

  getRegisteredVSBlockedPieChartData(filter:string): Observable<any> {
    return this.apiService.get('/reports/registeredvsblocked/piechart/'+filter)
    .pipe(
      map(
        res  =>  {
          console.log("response" +  res);
          return res
        },
        err => {
          console.log("error response" + err);
        }
      )
    );
  }

}